import React, { useEffect, useSyncExternalStore } from 'react';
import clsx from 'clsx';
import { NextUI } from '@/components/NextUI';
import { checkoutRevealStore } from '@/features/subscription/utils/checkout/checkoutRevealStore';
import type { PaywallCheckoutProps } from '../types';

const PaywallCheckoutFrame = ({
  checkoutContainerRef,
  paymentStatus,
  minHeight = 560,
  statusClassName = 'text-[#787887]',
  children,
}: Pick<PaywallCheckoutProps, 'checkoutContainerRef' | 'paymentStatus'> & {
  minHeight?: number;
  statusClassName?: string;
  children?: React.ReactNode;
}) => {
  useEffect(() => {
    checkoutRevealStore.setRevealTarget(checkoutContainerRef.current);
    return () => checkoutRevealStore.setRevealTarget(null);
  }, [checkoutContainerRef]);

  const contentHeight = useSyncExternalStore(
    checkoutRevealStore.subscribe,
    checkoutRevealStore.getContentHeight,
    () => null
  );
  const resolvedHeight = Math.max(minHeight, contentHeight ?? 0);

  return (
    <>
      {paymentStatus === 'loading' && (
        <div className="flex h-[120px] items-center justify-center">
          <NextUI.Spinner />
        </div>
      )}
      {paymentStatus === 'verifying' && (
        <div
          className={clsx(
            'flex h-[120px] items-center justify-center text-[15px]',
            statusClassName
          )}
        >
          We are checking your payment status...
        </div>
      )}
      <div className="relative">
        <div ref={checkoutContainerRef} style={{ minHeight: resolvedHeight }} />
        {children}
      </div>
    </>
  );
};

export default PaywallCheckoutFrame;
